import { apartments } from '@/data/apartments';
import { useLanguage } from '@/i18n/LanguageContext';
import { motion } from 'framer-motion';
import ApartmentCard from './ApartmentCard';

const ApartmentGallery = () => {
  const { t } = useLanguage();

  return (
    <section id="apartments" className="relative py-24 md:py-32">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16 text-center">

          <p className="font-serif-elegant uppercase tracking-[0.3em] text-primary/70 font-bold text-lg">
            Collection
          </p>
          <h2 className="mt-3 font-serif text-3xl tracking-wide text-foreground md:text-5xl">
            {t.apartments.title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-muted-foreground">
            {t.apartments.subtitle}
          </p>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-2">
          {apartments.map((apt, i) =>
          <ApartmentCard key={apt.id} apartment={apt} index={i} />
          )}
        </div>
      </div>
    </section>);

};

export default ApartmentGallery;